/* src/app/components/new-preprocess/new-preprocess.component.css */
.calendar-contrl {
  background-image: url(/assets/img/calendar.png);
  width: 2.75rem;
  background-repeat: no-repeat;
  background-size: 23px;
  background-position: center;
}
/*# sourceMappingURL=new-preprocess.component.css.map */
